<template>
    <div class="page_mobile_header flex-col">
        <div class="group_1 flex-row">
            <img
                    class="menu_logo"
                    @click="goHome"
                    referrerpolicy="no-referrer"
                    src="../../assets/header/logo.png"
            />
            <div class="block_1 flex-col"></div>
            <div class="logo-wrapper_1 flex-col">
                <span class="text_1">北京康柏汉森医药科技咨询有限责任公司</span>
                <span class="text_2">Beijing&nbsp;Comprehensive&nbsp;Pharmaceutical&nbsp;Consulting&nbsp;Co.,Ltd.</span>
            </div>
            <img
                    class="menu_more"
                    @click="showDrawerFun"
                    referrerpolicy="no-referrer"
                    src="../../assets/header/mobile_menu_more.png"
            />
        </div>
        <mobile-drawer  @close="closeDrawer" @selectMenu="selectMenu" ref="menu" :default-active-index="activeIndex"></mobile-drawer>
        <mobile-submenu @back="back" @closeSub="closeSub" :menuItem="menuData" v-if="showSecond"></mobile-submenu>
    </div>
</template>
<script>
    import MobileDrawer from "./MobileDrawer";
    import MobileSubmenu from "./MobileSubmenu";
    export default {
        props: {
            defaultActiveIndex: {
                type: Number,
                default: 0
            }
        },
        data() {
            return {
                menuData:{
                    id: 1,
                    label: '核心业务',
                    child: []
                },
                showDrawer:false,
                showSecond:false,
                activeIndex: this.defaultActiveIndex,
            };
        },
        components:{
            MobileDrawer,MobileSubmenu
        },
        watch: {
            // 监听props变化
            defaultActiveIndex(newVal) {
                this.activeIndex = newVal;
            }
        },
        methods: {
            showDrawerFun(){
                this.showDrawer = true;
                this.$refs.menu.open();
            },
            closeDrawer(){
                this.showDrawer = false;
            },
            //关闭子菜单
            back(){
                this.showSecond = false;
            },
            //关闭所有菜单
            closeSub(){
                this.showSecond = false;
                this.$nextTick(() => {
                    this.$refs.menu.closeMenu();
                });
                this.showDrawer = false;
            },
            selectMenu(item){
                console.log(item)
                this.menuData = item;
                this.showSecond = true;
            },
            goHome(){
                let url = "/"
                if (this.$route.path !== url){
                    this.$router.push(`${url}`).then(() => {
                        window.scrollTo(0, 0);
                    });
                }else{
                    window.scrollTo(0, 0);
                }
            },
        }
    };
</script>
<style scoped lang="css" >
    .page_mobile_header {
        background-color: rgba(255, 255, 255, 1);
        position: relative;
        max-width: 1200px;
        height: 60px;
        overflow: hidden;
        margin: 0 auto;
    }

    .group_1 {
        background-color: rgba(255, 255, 255, 1);
        padding: 21px 26px 21px 30px;
    }
    .flex-row {
        display: flex;
        flex-direction: row;
    }

    .menu_logo {
        cursor: pointer;
        width: 117px;
        height: 46px;
    }

    .block_1 {
        background-color: rgba(0, 153, 145, 0.35);
        width: 1px;
        height: 27px;
        margin: 10px 0 9px 10px;
    }
    .flex-col {
        display: flex;
        flex-direction: column;
    }

    .logo-wrapper_1 {
        margin: 4px 0 1px 10px;
    }

    .text_1 {
        height: 20px;
        overflow-wrap: break-word;
        color: rgba(0, 134, 131, 1);
        font-size: 17px;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: NaN;
        text-align: left;
        white-space: nowrap;
        line-height: 19px;
        margin-right: 12px;
    }

    .text_2 {
        height: 20px;
        overflow-wrap: break-word;
        color: rgba(0, 134, 131, 1);
        font-size: 11px;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: NaN;
        text-align: left;
        white-space: nowrap;
        line-height: 19px;
        margin-top: 1px;
    }

    .menu_more {
        width: 40px;
        height: 29px;
        margin: 8px 40px 9px auto;
    }

    @media (max-width: 480px) {
        .page_mobile_header {
            height: 60px;
        }

        .group_1 {
            padding: 10px 15px;
        }

        .menu_logo {
            width: 80px;
            height: 32px;
        }

        .block_1 {
            height: 20px;
            margin: 5px 0 5px 5px;
        }


        .logo-wrapper_1 {
            margin: 2px 0 1px 5px;
        }

        .text_1 {
            font-size: 12px;
            line-height: 14px;
            margin-right: 5px;
        }
        .text_2 {
            font-size: 8px;
            line-height: 10px;
        }

        .menu_more {
            width: 30px;
            height: 22px;
            margin: 5px 15px 5px auto;
        }
    }

</style>
